import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
 
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import './style.css';
import './mandasastyle.css';
import './rs-style.css';
 
import { ChakraProvider } from '@chakra-ui/react';
import { store } from "./store/store";
import { Provider } from "react-redux";
import { persistStore } from "redux-persist";
import { PersistGate } from "redux-persist/integration/react";
import { QueryClient, QueryClientProvider } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";
import MaintenainceCheck from "./MaintenainceCheck";
 
let persistor = persistStore(store);
const queryClient = new QueryClient();
 
/* 🔹 React 18 Root */
const container = document.getElementById('root');
const root = createRoot(container);
 
root.render(
  <BrowserRouter>
    <ChakraProvider cssVarsRoot="#app">
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <QueryClientProvider client={queryClient}>
            <MaintenainceCheck />
            <ReactQueryDevtools initialIsOpen={false} />
          </QueryClientProvider>
        </PersistGate>
      </Provider>
    </ChakraProvider>
  </BrowserRouter>
);